module.exports = __webpack_public_path__ + "static/media/rear-wheels.93f2ec39.svg";